import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HashLocationStrategy, LocationStrategy } from '@angular/common'
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { ViewModule } from './views/view.module'
import { ComponentsModule } from './components/components.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AdminApiCallsService } from './_services/admin-api-calls.service'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { HttpInterceptorsService } from './_services/http-interceptors.service'
import { NgxPaginationModule } from 'ngx-pagination'
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime'
import { ChartsModule } from 'ng2-charts'
import { CommonModule } from '@angular/common'
import { OrderModule } from 'ngx-order-pipe'
import { QuillModule } from 'ngx-quill'
import { NgxPrintModule } from 'ngx-print'
import { CacheIntercepror } from './_services/cache-interceptor.service'
import { RequestsService } from './_shared/services/requests.service'
import { ServerErrorInterceptor } from './_services/server-error.interceptor.service';
import { ServicesModule } from './services/services.module'
import { ProgressSpinnerModule } from 'primeng/progressspinner'



@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ViewModule,
    ComponentsModule,
    HttpClientModule,
    NgxPaginationModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ChartsModule,
    OrderModule,
    QuillModule,
    NgxPrintModule,
    ServicesModule,
    ProgressSpinnerModule
  ],
  providers: [
    AdminApiCallsService,
    HttpClientModule,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorsService,
      multi: true,
    },
    RequestsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheIntercepror,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
